import React, { createContext } from 'react'

export type AdminUiContextType = {
  advancedPlayerSettingsShowing: boolean;
  advancedWorkSettingsShowing: boolean;
  setAdvancedPlayerSettingsShowing: (show: boolean) => void;
  setAdvancedWorkSettingsShowing: (show: boolean) => void;
}

export const AdminUiContext = createContext<AdminUiContextType>({
  advancedPlayerSettingsShowing: false,
  setAdvancedPlayerSettingsShowing: () => { /* noop */ },
  advancedWorkSettingsShowing: false,
  setAdvancedWorkSettingsShowing: () => { /* noop */ },
})

type Props = {
  children?: React.ReactNode
};
export const AdminUiContextProvider: React.FC<Props> = ({ children }) => {
  const [advancedPlayerSettingsShowing, setAdvancedPlayerSettingsShowing] = React.useState(false)
  const [advancedWorkSettingsShowing, setAdvancedWorkSettingsShowing] = React.useState(false)
  return (
    <AdminUiContext.Provider
      value={{
        advancedPlayerSettingsShowing,
        setAdvancedPlayerSettingsShowing,
        advancedWorkSettingsShowing,
        setAdvancedWorkSettingsShowing,
      }}
    >
      { children }
    </AdminUiContext.Provider>
  )
}
